import { Box } from "@otrium/core";
import styled from "@emotion/styled";

const Wrapper = styled(Box)`
  flex: 1;
  padding: 0 5px 10px;
  .rc-slider {
    pointer-events: none;
    .rc-slider-handle {
      pointer-events: auto;
    }
  }
  .rc-slider-track,
  .rc-slider-handle {
    transition: width 100ms, transform 100ms, left 100ms;
  }
`;

export { Wrapper };
